import { render, staticRenderFns } from "./userDemo.vue?vue&type=template&id=be03aec8&scoped=true&"
import script from "./userDemo.vue?vue&type=script&lang=js&"
export * from "./userDemo.vue?vue&type=script&lang=js&"
import style0 from "./userDemo.vue?vue&type=style&index=0&id=be03aec8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be03aec8",
  null
  
)

export default component.exports